import React from 'react';

import {
  convertLocationParamsToFetchParams,
  useProcesses,
} from 'app/process/api';
import {PROCESS_CREATE_PAGE_URL} from 'app/urls';
import {getProcessName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';

import {DashboardSidebarCollapsableList} from './DashboardSidebarCollapsableList';

import type {ProcessDashboardFetchParamsType} from 'app/process/types';
import type {ProcessSerializedType} from 'sweet-types';

type Props = {
  canCreate: boolean;
};

export const DashboardSidebarProcessesList = ({canCreate}: Props) => (
  <DashboardSidebarCollapsableList<
    ProcessSerializedType,
    ProcessDashboardFetchParamsType
  >
    icon="fa-copy"
    title={gt('Processes')}
    reduxKey="processes"
    watchModelChange="process"
    showSearch={true}
    noResultsMessage={gt('No processes found')}
    canCreate={canCreate}
    createLink={PROCESS_CREATE_PAGE_URL}
    searchPlaceholder={gt('Search process...')}
    useDataHook={useProcesses}
    paramsConverter={convertLocationParamsToFetchParams}
    itemNameProcessor={(process) => getProcessName(process, true)}
  />
);
